export default "__VITE_ASSET__16eeb2f3__"